<template>
  <BaseView title="K-Diagram">
    <template #content>
      <div
        class="d-flex"
        style="height: 100%; position: relative"
      >
        <v-container
          v-show="drawer"
          style="
            height: 100%;
            max-height: 100%;
            position: absolute;
            width: 20em;
            padding: 0px;
            transition: width 0.4s ease;
            background-color: var(--color-bg);
          "
          @transitionend="onTransitionEnd"
        >
          <InputsDrawer @collapseButtonPressed="onCollapseButtonPressed" />
        </v-container>

        <v-btn
          v-if="!drawer"
          fab
          small
          color="primary"
          style="position: absolute; left: 0; bottom: 48%; z-index: 1"
          @click="onExpandButtonPressed"
        >
          <v-icon>mdi-chevron-double-right</v-icon>
        </v-btn>

        <div
          class="flex-grow-1"
          :style="{
            position: 'absolute',
            right: '0',
            bottom: '0',
            top: '0',
            left: drawer ? '20em' : '0',
            transition: 'left 0.4s ease',
          }"
          @transitionend="onTransitionEnd"
        >
          <KDiagramSuccessView
            v-if="!calculationLoading && !calculationError"
            ref="kDiagramSuccessView"
          />
          <KDiagramLoadingView v-if="calculationLoading" />
          <KDiagramErrorView
            v-if="calculationError "
          />
        </div>
        <SnackBar
          ref="errorSnackBar"
          style="position: absolute; bottom: 40px; left: 0"
        />
      </div>
    </template>
  </BaseView>
</template>

<script>
import { mapActions, mapState } from "vuex";
import KDiagramSuccessView from "./SuccessView.vue";
import KDiagramLoadingView from "./LoadingView.vue";
import InputsDrawer from "./components/InputsDrawer.vue";
import SnackBar from "@/core/SnackBar.vue";
import KDiagramErrorView from "./ErrorView.vue";
import BaseView from "../components/BaseView.vue";
export default {
  name: "VesselAlertsView",
  components: {
    InputsDrawer,
    KDiagramSuccessView,
    KDiagramLoadingView,
    KDiagramErrorView,
    SnackBar,
    BaseView,
  },

  data() {
    return {
      drawer: true,
      errorMessage:
        "Something went wrong during calculation. Displaying previous calculation results",
    };
  },
  computed: {
    ...mapState("kDiagram/profiles", ["profiles", "selectedProfile"]),
    ...mapState("kDiagram", [
      "calculationLoading",
      "calculationError",
      "calculationResult",
    ]),
    isSmallScreen() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isLargeScreen() {
      return this.$vuetify.breakpoint.smAndUp;
    },
  },
  methods: {
    ...mapActions("kDiagram/profiles", ["fetchProfiles"]),
    ...mapActions("kDiagram", [
      "calculateByPreset",
      "calculate",
      "fetchKDiagramSeaTrials",
      "fetchKDiagramStaticData",
    ]),
    async fetchInitialData(vesselName) {

      this.$store.commit("kDiagram/RESET_STATE");

      const seaTrialsPromise = this.fetchKDiagramSeaTrials(vesselName);
      const staticDataPromise = this.fetchKDiagramStaticData(vesselName);
      Promise.all([seaTrialsPromise, staticDataPromise]);
      this.$store.commit("kDiagram/profiles/RESET_STATE");
      await this.fetchProfiles(vesselName);
      if (this.profiles.length > 0) {
        this.$store.commit(
          "kDiagram/profiles/SET_SELECTED_PROFILE",
          this.profiles[0]
        );
        this.$store.commit(
          "kDiagram/SET_CALCULATION_DATA_ACCORDING_TO_PROFILE",
          this.profiles[0]
        );
        await this.calculateByPreset({
          vessel: vesselName,
          profileId: this.selectedProfile.id,
        });
      } else {
        await this.calculate(vesselName);
      }
    },
    onCollapseButtonPressed() {
      this.drawer = !this.drawer;
    },
    onExpandButtonPressed() {
      this.drawer = true;
    },
    onTransitionEnd(event) {
      if (!this.$refs.kDiagramSuccessView) {
        return;
      }
      if (event.propertyName === "width" || event.propertyName === "left") {
        this.$refs.kDiagramSuccessView.$refs.kDiagramCalculationSuccessViewLarge.reflowCharts();
      }
    },
  },
  watch: {
    async $route(next, previous) {
      const previousVesselName = previous.params.vessel;
      const nextVesselName = next.params.vessel;
      if (previousVesselName != nextVesselName) {
        this.fetchInitialData(nextVesselName);
      }
    },
    calculationError: {
      handler(value) {
        if (value !== null && this.calculationResult != null) {
          this.$refs.errorSnackBar.showMessage(this.errorMessage, {
            color: "error",
            timeout: 5000,
          });
        }
      },
      deep: true,
    },
  },
  async mounted() {
    this.fetchInitialData(this.$route.params.vessel);
  },
};
</script>

  <style scoped>
</style>
